import React, {Component} from 'react';
import WebNews from "../webNews/webNews";
import {Scrollbars} from "react-custom-scrollbars";
import {Col, Icon, Row} from "antd";
import {DetailDialog as Picture} from "../../../../../resource/view/dialog/picture/picture";
import "./fileItem.css"
import {uuid} from "../../../../../../utils";
import {checkWordReplace} from "../tool/htmlFormat";

/**
 * creat by tianruojun
 * @description 安全中心微博素材预览模块
 * @class Weibo
 * @extends {Component}
 */
export default class Weibo extends WebNews {
    constructor(props) {
        super(props);
        this.state.path = ""
    }
    componentWillMount() {
    }

    componentDidMount() {
    }
    /**
     * 给稿件数据打敏感词标记
     */
    setCheckWord = ({title="",summary="",content="",cover="",picUrls=[],tags=[]}) => {
        const {checkAllWord} = this.props;
        if(checkAllWord?.length) {
            checkAllWord.forEach(item=>{
                let itemWord = item.word;//错误词
                let currWord;
                let itemCorrectWord = item.correctWord;//正确词
                if (item.category === "SENSITIVE") {
                    currWord = '“' + itemWord + '”建议修改为：“' + itemCorrectWord + '”';
                } else {
                    currWord = '“' + itemWord + '”建议删除';
                }
                let replaceHtml = '<span class="itemWord word" check="'+currWord+'">'+itemWord+'</span>';
                content = checkWordReplace(content,item?.word,replaceHtml);
                title = checkWordReplace(title,item?.word,replaceHtml);
                summary = checkWordReplace(summary,item?.word,replaceHtml);
            })
        }
        return {title,summary,content,cover,picUrls,tags}
    };
    renderContent = () => {
        const height = window.innerHeight - 24 - 20;
        const width = window.innerWidth - 680;// 左右各留340距离
        const publicStyle = {
            fontWeight: '400',
            marginBottom: '24px'
        };
        let {title,summary,content,cover,picUrls,tags} = this.getData();
        if(content && cover && summary) {
            return this.renderToutiao({title,summary,content,cover,picUrls,tags,publicStyle,height,width})
        } else {
            return this.renderWeibo({title,summary,content,cover,picUrls,tags,publicStyle,height,width})
        }
    };

    renderToutiao = ({title,summary,content,cover,picUrls,tags,publicStyle,height,width}) => {
        return (
            <div className={'details_content'} style={{height: height,width}}>
                <Scrollbars autoHide autoHeightMax={height}>
                    <div style={{padding: '0 10px'}}>
                        {/*微博正文*/}
                        <div style={{
                            fontWeight: 700,
                            fontSize: 16,
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 24,
                        }}>
                            <div style={{
                                width: 4,
                                height: 16,
                                background: "#0050b3",
                                marginRight: 4,
                            }}></div>
                            <div>微博正文</div>
                        </div>
                        <div
                            style={{
                                ...publicStyle,
                                fontSize: 16,
                                textAlign: 'left',
                                color: 'rgba(0, 0, 0, 0.85)',
                            }}
                            dangerouslySetInnerHTML={{__html: title}}
                        >
                        </div>
                        {/*头条文章*/}
                        <div style={{
                            fontWeight: 700,
                            fontSize: 16,
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 24,
                        }}>
                            <div style={{
                                width: 4,
                                height: 16,
                                background: "#0050b3",
                                marginRight: 4,
                            }}></div>
                            头条文章
                        </div>
                        {/*摘要*/}
                        <div style={{
                            fontSize: 14,
                            color: 'rgba(0, 0, 0, 0.45)',
                            ...publicStyle,
                        }}
                             dangerouslySetInnerHTML={{__html: summary}}
                        >
                        </div>
                        {/*正文*/}
                        <div
                            style={{
                                fontSize: 16,
                                color: 'rgba(0, 0, 0, 0.65)',
                                ...publicStyle,
                            }}
                            dangerouslySetInnerHTML={{__html: content}}
                        >
                        </div>
                        {/*标题图*/}
                    </div>
                    <style>
                        {`
                        font.word {
                        color: #fff;
                        background-color: red;
                        cursor: pointer;
                        }
                    `}
                    </style>
                </Scrollbars>

            </div>
        )
    };
    renderWeibo = ({title,summary,content,cover,picUrls,tags,publicStyle,height,width}) => {
        return (
            <div className={'details_content'} style={{height: height,width}}>
                <Scrollbars autoHide autoHeightMax={height}>
                    <div style={{padding: '0 10px'}}>
                        {/*微博正文*/}
                        <div
                            style={{
                                ...publicStyle,
                                fontSize: 16,
                                textAlign: 'left',
                                color: 'rgba(0, 0, 0, 0.85)',
                            }}
                            dangerouslySetInnerHTML={{__html: title}}
                        >
                        </div>
                        {/*图片列表区*/}
                        {
                            picUrls?.length ? (
                                <div style={{width: 436}}>
                                    <Row gutter={[8,8]}>
                                        {
                                            picUrls.map((item,index)=>
                                                <Col span={8} key={index}>
                                                    <div className={"rmt-fileItem"}
                                                         style={{verticalAlign: "middle", textAlign: "center"}}>
                                                        <div className={"hover"}>
                                                            <div style={{
                                                                width: 140,
                                                                height: 140,
                                                                background: 'rgba(0,0,0,0.4)',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                position: 'absolute',
                                                                padding: '0 10px',
                                                                top: 3,
                                                                zIndex: 999,
                                                            }}
                                                                 onClick={() => {
                                                                     this.setState({path: item}, () => {
                                                                         this.picture.show()
                                                                     })
                                                                 }}
                                                            >
                                                                <Icon type={'eye'}
                                                                      style={{
                                                                          width: 25,
                                                                          height: 25,
                                                                          color: "#fff",
                                                                          marginRight: 10,
                                                                          cursor: 'pointer'
                                                                      }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <img src={item}
                                                             style={{width: 140, height: 140, objectFit: "cover"}}/>
                                                    </div>
                                                </Col>
                                            )
                                        }
                                    </Row>
                                </div>
                            ) : ""
                        }
                        <Picture key={uuid()} ref={ref => this.picture = ref} path={this.state.path} />
                    </div>
                    <style>
                        {`
                        font.word {
                        color: #fff;
                        background-color: red;
                        cursor: pointer;
                        }
                    `}
                    </style>
                </Scrollbars>
            </div>
        )
    };
}